import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const state = {
  client: {
    general: {},
    excursionManagement: {},
    excursionManagementVendorsList: [],
    contentEngine: {},
    provider: {},
    studentManagement: {},
    studentManagementVendorsList: []
  }
};

const store = {
  actions,
  getters,
  mutations,
  namespaced: true,
  state
};

export default store;
